// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__kx3zn","footer":"ModalUpdate_footer__aV_P1"};